import type { WeekStartsOn } from '../profile/profileModel';

export type WeekStartDay = 'sunday' | 'monday';

export const WEEK_START_OPTIONS: { value: WeekStartDay; label: string }[] = [
  { value: 'sunday', label: 'Sunday' },
  { value: 'monday', label: 'Monday' },
];

/** Undefined (not loaded yet) is Sunday, the server's own default. */
export function weekStartDay(weekStartsOn: WeekStartsOn | undefined): WeekStartDay {
  return weekStartsOn === 1 ? 'monday' : 'sunday';
}

export function weekStartsOnOf(day: WeekStartDay): WeekStartsOn {
  return day === 'monday' ? 1 : 0;
}

export interface WeekStartChoice {
  value: WeekStartDay;
  status: 'idle' | 'saving' | 'saved';
  error: string | null;
}

/**
 * Picking a day saves it at once (copied from studio-fripp): the control shows
 * the new day while the PUT runs, then "Saved", or the previous day again with
 * the server's message. A pick while a save is in flight, or of the day already
 * shown, does nothing.
 */
export async function chooseWeekStart(
  current: WeekStartChoice,
  next: WeekStartDay,
  save: (weekStartsOn: WeekStartsOn) => Promise<void>,
  update: (choice: WeekStartChoice) => void,
): Promise<void> {
  if (current.status === 'saving' || next === current.value) return;
  update({ value: next, status: 'saving', error: null });
  try {
    await save(weekStartsOnOf(next));
    update({ value: next, status: 'saved', error: null });
  } catch (error) {
    update({
      value: current.value,
      status: 'idle',
      error: error instanceof Error ? error.message : 'Week start was not saved.',
    });
  }
}
